// Enums
import { EnvName } from '@enums/environment.enum';

// Packages
import packageInfo from '../../package.json';

export const environment = {
  production      : true,
  version         : packageInfo.version,
  appName         : 'Navigator',
  envName         : EnvName.DEV,
  defaultLanguage : 'en',
  apiBaseUrl      : 'https://api.navigator.dev.s-marketing.ch',
};
